import type React from 'react';
import SocialLinks from 'components/SocialLinks';
import SubscriptionPlea from 'components/SubscriptionPlea';
import RawHtml from 'utils/miscUtils/rawHtml';
import type { Longform } from 'interfaces/content/articles/Post';
import { Footer, RightRailFlexArticlesList } from 'components/Ad/AdSlot';
import LongformHero from 'components/Longform/LongformHero';
import useDateTime from 'hooks/useDateTime';
import ContentWithEmbed from 'components/ContentWithEmbed';
import AdminBar from 'components/AdminBar';
import ErrorBoundary from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import AboutTheContributors from 'components/AboutTheContributors';
import {
  LongformBodyWrapper,
  LongformBodyContainer,
  LongformSocialContainer,
  LongformContentContainer,
} from './LongformStyles';

export interface LongformProps {
  longform: Longform;
  adFrequency: number;
}

const LongformPage: React.FC<LongformProps> = ({ longform, adFrequency }) => {
  const {
    audienceDek,
    authors,
    content,
    databaseId,
    dateGmt,
    description,
    featuredMediaType,
    heroBuilder: { landscapeVideoLayerVodVideoId, heroLayout },
    image,
    pageType,
    postSettings: { postSettingsDek, enableSubscriptionPlea, subscriptionPleaTextLined },
    title,
  } = longform;

  const localDate = useDateTime(dateGmt);

  return (
    <article id='content'>
      <ErrorBoundary fragment={UIFragments.LONGFORM_PAGE}>
        <AdminBar pageId={databaseId} />
      </ErrorBoundary>

      <ErrorBoundary fragment={UIFragments.LONGFORM_PAGE}>
        <LongformHero
          heroLayout={heroLayout}
          title={title}
          postSettingsDek={postSettingsDek}
          audienceDek={audienceDek}
          description={description}
          authors={authors}
          localDate={localDate}
          videoId={landscapeVideoLayerVodVideoId || ''}
          mediaType={featuredMediaType}
          mediaItem={image}
        />
      </ErrorBoundary>

      <LongformBodyWrapper>
        <ErrorBoundary fragment={UIFragments.LONGFORM_PAGE}>
          <LongformSocialContainer>
            <SocialLinks title={title} />
          </LongformSocialContainer>
        </ErrorBoundary>

        <LongformBodyContainer>
          <ErrorBoundary fragment={UIFragments.LONGFORM_PAGE}>
            <LongformContentContainer id='gutenbergContent'>
              <ContentWithEmbed
                embedInstructions={[{ index: 4, node: 'p' }]}
                adFrequency={adFrequency}
                section={longform.primarySection.name}
                articleUrl={longform.url}
              >
                <div className='rawHtml-content'>{RawHtml({ html: content })}</div>
              </ContentWithEmbed>
            </LongformContentContainer>
          </ErrorBoundary>

          <ErrorBoundary fragment={UIFragments.LONGFORM_PAGE}>
            <SubscriptionPlea
              enableSubscriptionPlea={enableSubscriptionPlea}
              subscriptionPleaTextLined={subscriptionPleaTextLined}
              pageType={pageType}
            />
          </ErrorBoundary>
          {authors.length > 0 && (
            <AboutTheContributors
              authors={authors}
              isEducation={false}
            />
          )}
        </LongformBodyContainer>

        <ErrorBoundary fragment={UIFragments.LONGFORM_PAGE}>
          <RightRailFlexArticlesList
            marginTop={heroLayout === 'portrait' ? 450 : 16}
            count={3}
          />
        </ErrorBoundary>
      </LongformBodyWrapper>

      <ErrorBoundary fragment={UIFragments.LONGFORM_PAGE}>
        <Footer id={0} />
      </ErrorBoundary>
    </article>
  );
};
export { LongformPage };
